export const USER_ACCESS_TOKEN_KEY = 'gta_user_access_token';
export const USER_REFRESH_TOKEN_KEY = 'gta_user_access_token';
export const ADMIN_ACCESS_TOKEN_KEY = 'gta_admin_access_token';
export const ADMIN_REFRESH_TOKEN_KEY = 'gta_admin_refresh_token';
